var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"fa fa-building",style:({opacity: _vm.ad.agency_commission ? 1 : 0.2})})
}
var staticRenderFns = []

export { render, staticRenderFns }